import { Link } from 'react-router-dom';
import type { VenteListItem } from '@cockpit/shared';
import { StatutPaiementBadge } from '../ui/Badge';
import { formatDate, formatEuro } from '../../lib/format';

interface Props {
  items: VenteListItem[];
}

export function VentesTable({ items }: Props): JSX.Element {
  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-xl overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-900 border-b border-slate-800">
          <tr className="text-left text-xs text-slate-400 uppercase tracking-wider">
            <th className="px-4 py-3">Date</th>
            <th className="px-4 py-3">N° facture</th>
            <th className="px-4 py-3">Client</th>
            <th className="px-4 py-3">Commercial</th>
            <th className="px-4 py-3 text-right">Total HT</th>
            <th className="px-4 py-3 text-right">Total TTC</th>
            <th className="px-4 py-3">Statut</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-800">
          {items.map((v) => (
            <tr key={v.id} className="hover:bg-slate-900/60 transition-colors">
              <td className="px-4 py-3 text-slate-200 whitespace-nowrap">
                {formatDate(v.date_vente)}
              </td>
              <td className="px-4 py-3 text-slate-400 text-xs">
                {v.numero_facture_henrri ?? <span className="italic text-slate-600">—</span>}
              </td>
              <td className="px-4 py-3 text-slate-100">
                <Link to={`/ventes/${String(v.id)}`} className="hover:text-floryon-green">
                  <div className="font-medium">{v.contact_nom}</div>
                  {v.contact_societe !== null && (
                    <div className="text-xs text-slate-500">{v.contact_societe}</div>
                  )}
                </Link>
              </td>
              <td className="px-4 py-3 text-xs text-slate-400 capitalize">
                {v.created_by_username}
              </td>
              <td className="px-4 py-3 text-right text-slate-200">
                {formatEuro(v.total_ht_centimes)}
              </td>
              <td className="px-4 py-3 text-right text-slate-100 font-medium">
                {formatEuro(v.total_ttc_centimes)}
              </td>
              <td className="px-4 py-3">
                <StatutPaiementBadge statut={v.statut_paiement} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
